/* unplugin-vue-components disabled */import script from "./PoWa.vue?vue&type=script&setup=true&lang=ts"
export * from "./PoWa.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__